// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wingull: PokeData = {
  "id": 278,
  "name": "wingull",
  "height": 6,
  "weight": 95,
  "base_experience": 54,
  "types": [
    PokeType.WATER,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "growl",
    "supersonic",
    "mist",
    "water-gun",
    "agility",
    "quick-attack",
    "pursuit",
    "air-cutter",
    "aerial-ace",
    "water-pulse",
    "roost",
    "air-slash",
    "hurricane"
  ],
  "moves": [
    "growl",
    "supersonic",
    "quick-attack",
    "pursuit",
    "aerial-ace",
    "roost",
    "air-slash",
    "hurricane",
    "peck",
    "brine",
    "brave-bird",
    "hydro-pump",
    "rain-dance"
  ],
  "evolution_chain": {
    "id": 139,
    "item": null,
    "species": [
      {
        "name": "wingull",
        "order": 303,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pelipper",
        "order": 304,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 278,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 35,
    "speed": 85,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
